module.exports = __webpack_public_path__ + "img/close-circle-outline-gray.b7c83ee5.svg";